const changeNum = (n) => {
    let num = String(n)
    let arr = num.split('.')
    let result;

    if (arr[1]) {
        result = Number(arr[0]).toLocaleString() + "." + arr[1]
    }
    else {
        result = Number(arr[0]).toLocaleString()
    }

    return result;
}

const formatDateTime = (date) => {
    return date.toISOString().slice(0, 19).replace("T", " ");
};

export { changeNum, formatDateTime }